import Vue from 'vue'
import VueRouter from 'vue-router'
import register from '../views/register.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'register',
    component: register
  },
  {
    path: '/r',
    name: 'register',
    // 路由懒加载示例
    component: () => import(/* webpackChunkName: "about" */ '../views/register.vue')
  }
]

const router = new VueRouter({
  mode: 'history',  // 使用 history 模式（需要服务器配置支持）
  base: process.env.BASE_URL,
  routes
})

export default router